import Box from '@components/kit/box'
import { HeaderBackButton } from '@components/kit/header'
import Text from '@components/kit/text'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import AppShell from '@components/ui/app-shell'
import PageHeader from '@components/ui/page-header'
import { useNavigate } from 'react-router-dom'
import { useOpportunityStore } from '@store/Opportunity'
import {
  IOpportunityCategory,
  IOpportunityDetails
} from '@store/Opportunity/types'
import Loading from '@components/kit/loading'
import {
  getOpportunityDetailTitle,
  getOpportunityDetailValue,
  shouldRenderOpportunityDetail
} from '@utils/opportunity'

function OpportunityDetail() {
  const { categoryId, opportunityId } = useParams()
  const navigate = useNavigate()
  const { getOpportunityDetailsFromId } = useOpportunityStore.getState()
  const categoryFound: IOpportunityCategory | undefined = useOpportunityStore(
    state => state.findOpportunityCategoryById(parseInt(categoryId))
  )

  const [opportunityDetails, setOpportunityDetails] =
    useState<IOpportunityDetails | null>(null)

  useEffect(() => {
    getOpportunityDetailsFromId(opportunityId).then(response => {
      if (response) {
        setOpportunityDetails(response)
      } else {
        console.error('Error fetching opportunity details')
      }
    })
  }, [opportunityId, getOpportunityDetailsFromId])

  return (
    <AppShell activePage='opportunities' label='Opportunity Detail'>
      <Box alignItems='center' flexDirection='row' mb='08'>
        <HeaderBackButton
          accessibilityHint='Go back to the previous screen'
          accessibilityLabel='Back'
          accessibilityRole='button'
          ml='-12'
          onPress={() => {
            navigate(`/opportunities/category/${categoryId}`)
          }}
        />
      </Box>

      <PageHeader
        eyebrow='Opportunities'
        title={categoryFound?.title || 'Opportunity Details'}
      />

      {opportunityDetails ? (
        Object.keys(opportunityDetails)?.map((key, index) => {
          if (!shouldRenderOpportunityDetail(key)) {
            return null
          }

          const detailValue = getOpportunityDetailValue(
            key,
            opportunityDetails[key]
          )
          const isValueArray = Array.isArray(detailValue)

          return (
            <Box flexDirection='row' key={index} mt='08'>
              <Text
                font='pro.text.14.semibold'
                textColor='proInk'
                textTransform='capitalize'
              >
                {`${getOpportunityDetailTitle(key)}:`}
              </Text>
              {isValueArray ? (
                <Box flex='1 1 auto' ml='08'>
                  {(detailValue as string[]).map((item, itemIndex) => (
                    <Text
                      font='pro.text.14.regular'
                      key={itemIndex}
                      textColor='proTextBody'
                    >
                      {` ${item}`}
                    </Text>
                  ))}
                </Box>
              ) : (
                <Text font='pro.text.14.regular' textColor='proTextBody'>
                  {` ${detailValue}`}
                </Text>
              )}
            </Box>
          )
        })
      ) : (
        <Box mt='32'>
          <Loading size='medium' />
        </Box>
      )}
    </AppShell>
  )
}

export default OpportunityDetail
